var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpGreenSU(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "spGreen_s_u",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.003,
    height: 56.003,
    viewBox: "0 0 56.003 56.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON_Green_Stop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_5766",
    "data-name": "\\u30D1\\u30B9 5766",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(11.995 12)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_1497",
    "data-name": "\\u30D1\\u30B9 1497",
    d: "M0,0H56V56H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_2699",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 2699",
    transform: "translate(13.998 13.997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_3006",
    "data-name": "\\u9577\\u65B9\\u5F62 3006",
    width: 28,
    height: 28,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5408\\u4F53_2",
    "data-name": "\\u5408\\u4F53 2",
    d: "M3.267,22l-.933-6.111H5.892V13.261H0L3.675,7.68H1.828L7,0l5.172,7.68H10.344L14,13.261H8.128v2.628h3.539L10.733,22Z",
    transform: "translate(7 3)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpGreenSU);
export default __webpack_public_path__ + "static/media/spGreen_s_u.b6e81831f7a0e727911123c37e622a13.svg";
export { ForwardRef as ReactComponent };